module.exports = __webpack_public_path__ + "static/img/case-1nongji.cccbcb47.jpg";